import { createApi } from "@reduxjs/toolkit/query/react";
import { APICall } from "@/config/NetworkUtility";

const customBaseQuery = async ({ url, method, body, params }) => {
    try {
        const query = params ? new URLSearchParams(params).toString() : "";
        const endpoint = query ? `${url}?${query}` : url;

        const result = await APICall(method, body ?? null, endpoint);

        return { data: result };
    } catch (error) {
        return {
            error: {
                status: error?.response?.status || 500,
                data: error?.response?.data || error?.message || "Request failed",
            },
        };
    }
};

export const officeTypeApi = createApi({
    reducerPath: "officeTypeApi",
    baseQuery: customBaseQuery,
    tagTypes: ["OfficeType"],

    endpoints: (builder) => ({
        getOfficeTypes: builder.query({
            query: (params = {}) => ({
                url: "v1/Common/OfficeTypes/GetAll",
                method: "get",
                params,
            }),
            transformResponse: (response) => response?.data || response || [],
            providesTags: ["OfficeType"],
        }),

        createOfficeType: builder.mutation({
            query: (payload) => ({
                url: "v1/Common/OfficeTypes/CreateNew",
                method: "post",
                body: payload,
            }),
            transformResponse: (response) => response?.data || response,
            invalidatesTags: ["OfficeType"],
        }),

        updateOfficeType: builder.mutation({
            query: (payload) => ({
                url: "v1/Common/OfficeTypes/Update",
                method: "post",
                body: payload,
            }),
            transformResponse: (response) => response?.data || response,
            invalidatesTags: ["OfficeType"],
        }),
        deleteOfficeType: builder.mutation({
            query: (payload) => ({
                url: "v1/Common/OfficeTypes/Delete",
                method: "post",
                body: payload,
            }),
            transformResponse: (response) => response?.data || response,
            invalidatesTags: ["OfficeType"],
        }),
    }),
});

export const {
    useGetOfficeTypesQuery,
    useCreateOfficeTypeMutation,
    useUpdateOfficeTypeMutation,
    useDeleteOfficeTypeMutation,
} = officeTypeApi;